import { TabOrder } from 'components/user/user-detail/tab-order/TabOrder'
import { INITIAL_DATA_FILTER } from 'configs/user/user-detail/configTableOrder'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import moment from 'moment/moment'
import { useLocation, useSearchParams } from 'react-router-dom'

export const TabOrderContainer = ({ id }) => {
    const location = useLocation()
    const [modalExport, setModalExport] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const query = getAllQueryParams(searchParams)
    const {
        data: orderList,
        fetching: getOrderListApi,
        isLoading,
    } = useFetch({ ...API_USER.ORDER_LIST, initPathVariable: id }, INITIAL_DATA_FILTER)
    const { fetching: exportOrderListApi } = useFetch({ ...API_USER.EXPORT_ORDER, initPathVariable: id })

    useEffect(() => {
        const { tabName, userId, ...queryParams } = query
        getOrderListApi({ ...queryParams })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const onExport = () => {
        const { tabName, userId, page, limit, ...queryParams } = query
        exportOrderListApi(queryParams, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `User-Order-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setModalExport(false)
        })
    }

    const props = {
        dataList: orderList?.data,
        query,
        onChangeQuery,
        modalExport,
        setModalExport,
        onExport,
        isLoading,
    }

    return <TabOrder {...props} />
}
